var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ebn-tracking"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("EBN Tracking - Bag/AWB Search")]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearchSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Search By")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.resetSearch]
    }
  }, [_c('option', {
    attrs: {
      "value": "bag"
    }
  }, [_vm._v("Bag Number")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "awb"
    }
  }, [_vm._v("AWB Number")])])])], 1)], 1), _vm._v(" "), (_vm.searchType === 'bag') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-search'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNumber),
      expression: "bagNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag Number",
      "name": "bagNumber",
      "id": "bagNumber"
    },
    domProps: {
      "value": (_vm.bagNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNumber = $event.target.value
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.searchType === 'awb') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("AWB Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-search'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbNumber),
      expression: "awbNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter AWB Number",
      "name": "awbNumber",
      "id": "awbNumber"
    },
    domProps: {
      "value": (_vm.awbNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbNumber = $event.target.value
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-top": "28px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    staticStyle: {
      "margin-top": "28px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_vm._v("Reset")])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSearchLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSearchLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.searchResults.length > 0) ? _c('div', [_c('br'), _vm._v(" "), _c('h5', [_vm._v("EBN Tracking Results")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB / Bag Number")]), _vm._v(" "), (_vm.searchType === 'bag') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("EBN Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("EBN Message")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.searchResults), function(result, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(result.identifier))]), _vm._v(" "), (_vm.searchType === 'bag') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(result.shippingId))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(result.ewayBillNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(result.ebnMessage))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(result.status === 'success') ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Success")]) : (result.status === 'error' || result.status === 'failed' || result.status === 'partial_failure') ? _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v(_vm._s(result.status))]) : _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v(_vm._s(result.status))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(result.createdDate))])])
  }), 0)])]) : (_vm.searchAttempted && _vm.searchResults.length === 0) ? _c('div', [_c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("No records found.")])]) : _vm._e()], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd522522","hasScoped":true}!./src/views/components/NetworkManagement/EBNTracking/EBNTracking.html
// module id = 967
// module chunks = 2